import { Link } from "react-router-dom";
import { BRAND } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="flex items-baseline gap-2 flex-wrap">
            <span className="font-serif text-2xl text-white">Elite Development Consultants</span>
            <span className="overline text-[#d4af37]">USA LLC</span>
          </div>
          <p className="mt-5 text-white/50 font-light max-w-md leading-relaxed">
            {BRAND.positioning}. Owner-side advisory for residential & commercial development, nationwide.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-5">Contact</p>
          <a href={BRAND.phoneHref} className="block text-white/75 hover:text-[#d4af37] transition-colors mb-2">{BRAND.phone}</a>
          <a href={BRAND.emailHref} className="block text-white/75 hover:text-[#d4af37] transition-colors break-all mb-4">{BRAND.email}</a>
          <p className="text-white/50 font-light text-sm leading-relaxed">
            {BRAND.address[0]}
            <br />
            {BRAND.address[1]}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-5">Firm</p>
          <p className="text-white/60 font-light text-sm leading-relaxed">
            Also known as Elite Owner’s Representation Group. Combined construction &amp; development
            expertise — 22+ years in business across residential and commercial projects.
          </p>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/30 text-xs tracking-wide">
          © {new Date().getFullYear()} Elite Development Consultants USA LLC. All rights reserved.
        </p>
        <Link data-testid="footer-admin-link" to="/admin" className="text-white/25 text-xs hover:text-[#d4af37] transition-colors tracking-wide">
          Client / Admin Access
        </Link>
      </div>
    </div>
  </footer>
);
